import {PriceInputProps} from '../components/price-input';

export const getPriceInput =
  <T>(data: Omit<PriceInputProps<T>, 'type'>) =>
  (): PriceInputProps<T> => ({
    ...data,
    type: 'price-input',
  });
